<script></script>
<div class="page-not-found">
    <div>
        <img src="images/event-logo.png" alt="home-logo" class="main-logo-img">
        <h2>Page not found</h2>
    </div>
</div>


<style>
    .page-not-found {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: url(../images/home-banner.png) no-repeat center;
        background-size: cover;
    }

    h2 {
        color: #ffffff;
        text-align: center;
        margin-top: 2em;
    }
</style>